import React, { useEffect, useState } from 'react'
import { Button, Drawer, Form, Input, Select, Space } from 'antd'

import { AxiosResponse } from 'axios'
import {
  getTiposMedidas,
  postCadastrarMedidas,
  putCadastrarMedidas,
} from '../../../../../services/cadastrarCultura';
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../../utils/alert'

interface TypesCadastrarCultura {
  open: boolean
  update: number
  onClose?: (data: boolean) => void
  tipoMedidas?: any[]
}

const FormCadastarMedidas: React.FC<TypesCadastrarCultura> = (props) => {
  const { open, update, onClose, tipoMedidas } = props

  const [form] = Form.useForm()

  const [dataTipoMedidas, setDataTipoMedida] = useState([])
  const [openDrawer, setOpenDrawer] = useState(false)

  // const editAtivo = async (cod) => {
  //   const resp: AxiosResponse<TypeCategoriaProdutos> = await getCategoriaProdutos({ cod })

  //   form.setFieldsValue(resp.data.itens[0])
  // }

  const hancleDrawerClose = () => {
    onClose(false)
    form.resetFields()
  }

  const editMedidas = async (cod) => {
    loadingAlert({msg: 'Carregando...', id: 'load_edit'})
    const resp: AxiosResponse = await getTiposMedidas()

    const dados = resp.data.itens
    const dataMedidas = dados.filter((item) => item.cod === cod)
    const nome = dataMedidas.map((n) => n.nome)
    const codTipo = dataMedidas.map((c) => c.cod_tipo)

    form.setFieldsValue({ nome: nome[0] })
    form.setFieldsValue({ cod_tipo: codTipo[0] })
    destroyAlert('load_edit');
  }

  const onFinish = async (data) => {
    try {
      loadingAlert({msg: 'Salvando...', id: 'save_cultura'});
      if (update <= 0) {
        const resp = await postCadastrarMedidas(data)

        if (resp.status === 201) {
          successAlert('Cultura salva com sucesso!', 5000, 'save_cultura');
          hancleDrawerClose()
          form.resetFields()
        }
      } else {
        const resp = await putCadastrarMedidas(update, data)

        if (resp.status === 200) {
          successAlert('Cultura atualizada com sucesso!', 5000, 'save_cultura');
          hancleDrawerClose()
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha na operação', 7000, 'save_cultura');
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha na operação', 7000, 'save_cultura');
          })
        }
      }
      else {
        errorAlert('Falhao na operação! (sem resposta)', 7000, 'save_cultura');
      }
    }
  }

  function removeDuplicateObjects(arr) {
    const uniqueObjects = new Map()

    arr.forEach((obj) => {
      if (!uniqueObjects.has(obj.cod_tipo)) {
        uniqueObjects.set(obj.cod_tipo, obj)
      }
    })

    return Array.from(uniqueObjects.values())
  }

  useEffect(() => {
    setOpenDrawer(open)
    const uniqueIds = removeDuplicateObjects(tipoMedidas)
    setDataTipoMedida(uniqueIds)
  }, [open])

  useEffect(() => {
    if (update > 0) {
      editMedidas(update)
    }
  }, [update])

  // useEffect(() => {
  //   listTipos()
  // }, [])

  return (
    <Form form={form} layout='vertical' onFinish={onFinish}>
      <Drawer
        placement='right'
        style={{ position: 'absolute' }}
        getContainer={false}
        open={open}
        closeIcon={false}
        onClose={() => hancleDrawerClose()}
        footer={
          <Space>
            <Button type='primary' htmlType='submit'>
              {update > 0 ? 'Atualizar' : 'Salvar'}
            </Button>
            <Button type='primary' danger onClick={() => hancleDrawerClose()}>
              Fechar
            </Button>
          </Space>
        }
      >
        {update > 0 ? (
          <h2 style={{ fontSize: '20px', fontWeight: 'bold' }}>Atualizar medidas</h2>
        ) : (
          <h2 style={{ fontSize: '20px', fontWeight: 'bold' }}>Cadastrar medidas</h2>
        )}
        <Form.Item label='Nome' name='nome'>
          <Input />
        </Form.Item>

        <Form.Item label='Tipo' name='cod_tipo'>
          <Select placeholder='Selecione o tipo '>
            {dataTipoMedidas?.map((data) => (
              <Select.Option key={data.cod_tipo} value={data.cod_tipo}>
                {data.tipo_nome}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Drawer>
    </Form>
  )
}

export default FormCadastarMedidas
